import React, { useState, useEffect } from 'react';
import './WordPressSites.css';

function WordPressSites({ user }) {
  const [sites, setSites] = useState([]);
  const [showAddForm, setShowAddForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [deleteConfirm, setDeleteConfirm] = useState(null);
  const [formData, setFormData] = useState({
    site_name: '',
    site_url: '',
    api_key: ''
  });

  useEffect(() => {
    loadWordPressSites();
  }, []);

  const loadWordPressSites = async () => {
    try {
      const response = await fetch('https://contentvertex.zealcart.com/api/wordpress-sites', {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('auth_token')}`,
          'Content-Type': 'application/json'
        }
      });
      const data = await response.json();
      if (data.success) {
        setSites(data.sites);
      }
    } catch (error) {
      console.error('Failed to load WordPress sites:', error);
    }
  };

  const handleAddSite = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch('https://contentvertex.zealcart.com/api/wordpress-sites', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('auth_token')}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();
      if (data.success) {
        setSites([...sites, data.site]);
        setShowAddForm(false);
        setFormData({ site_name: '', site_url: '', api_key: '' });
        alert('WordPress site added successfully!');
      } else {
        alert('Failed to add site: ' + data.message);
      }
    } catch (error) {
      alert('Failed to add WordPress site');
    } finally {
      setLoading(false);
    }
  };

  const testConnection = async (site) => {
    try {
      const response = await fetch(`https://contentvertex.zealcart.com/api/wordpress-sites/${site.id}/test`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('auth_token')}`,
          'Content-Type': 'application/json'
        }
      });

      const data = await response.json();
      if (data.success) {
        alert(`Connection successful!\nSite: ${data.site_info.site_name}`);
      } else {
        alert('Connection failed: ' + data.message);
      }
    } catch (error) {
      alert('Connection test failed');
    }
  };

const deleteSite = async (siteId) => {
  setDeleteConfirm(siteId);
};

const confirmDelete = async () => {
  try {
    const response = await fetch(`https://contentvertex.zealcart.com/api/wordpress-sites/${deleteConfirm}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
      }
    });

    if (response.ok) {
      setSites(sites.filter(site => site.id !== deleteConfirm));
      alert('WordPress site removed successfully');
    }
    setDeleteConfirm(null);
  } catch (error) {
    alert('Failed to remove site');
    setDeleteConfirm(null);
  }
};

  return (
    <div className="wordpress-sites-container">
      <div className="sites-header">
        <h2>WordPress Sites</h2>
        <button 
          className="btn btn-primary"
          onClick={() => setShowAddForm(true)}
        >
          + Add WordPress Site
        </button>
      </div>

      {showAddForm && (
        <div className="add-site-modal">
          <div className="modal-content">
            <div className="modal-header">
              <h3>Add WordPress Site</h3>
              <button 
                className="close-btn"
                onClick={() => setShowAddForm(false)}
              >
                ×
              </button>
            </div>

            <form onSubmit={handleAddSite}>
              <div className="form-group">
                <label>Site Name</label>
                <input
                  type="text"
                  placeholder="My Blog"
                  value={formData.site_name}
                  onChange={(e) => setFormData({...formData, site_name: e.target.value})}
                  required
                />
              </div>

              <div className="form-group">
                <label>Site URL</label>
                <input
                  type="url"
                  placeholder="https://yourblog.com"
                  value={formData.site_url}
                  onChange={(e) => setFormData({...formData, site_url: e.target.value})}
                  required
                />
              </div>

              <div className="form-group">
                <label>API Key</label>
                <input
                  type="text"
                  placeholder="cv_xxxxxxxxxxxxxxxxx"
                  value={formData.api_key}
                  onChange={(e) => setFormData({...formData, api_key: e.target.value})}
                  required
                />
                <small>Get this from Settings → ContentVertex Bridge in your WordPress admin</small>
              </div>

              <div className="form-actions">
                <button type="button" onClick={() => setShowAddForm(false)}>
                  Cancel
                </button>
                <button type="submit" disabled={loading}>
                  {loading ? 'Adding...' : 'Add Site'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      <div className="sites-grid">
        {sites.length === 0 ? (
          <div className="no-sites">
            <p>No WordPress sites connected yet.</p>
            <p>Add your first site to start publishing articles directly to WordPress!</p>
          </div>
        ) : (
          sites.map(site => (
            <div key={site.id} className="site-card">
              <div className="site-header">
                <h3>{site.site_name}</h3>
                <span className={`status ${site.status}`}>
                  {site.status === 'connected' ? '🟢' : '🔴'} 
                  {site.status}
                </span>
              </div>
              
              <div className="site-details">
                <p><strong>URL:</strong> {site.site_url}</p>
                <p><strong>Added:</strong> {new Date(site.created_at).toLocaleDateString()}</p>
              </div>

              <div className="site-actions">
                <button 
                  className="btn btn-secondary"
                  onClick={() => testConnection(site)}
                >
                  Test Connection
                </button>
                <button 
                  className="btn btn-danger"
                  onClick={() => deleteSite(site.id)}
                >
                  Remove
                </button>
              </div>
            </div>
          ))
        )}
      </div>
      {deleteConfirm && (
  <div className="delete-confirm-modal">
    <div className="modal-content">
      <h3>Confirm Delete</h3>
      <p>Are you sure you want to remove this WordPress site?</p>
      <div className="modal-actions">
        <button onClick={() => setDeleteConfirm(null)}>Cancel</button>
        <button onClick={confirmDelete} className="btn-danger">Delete</button>
      </div>
    </div>
  </div>
)}
    </div>
  );
}

export default WordPressSites;